import React from 'react';
import {
  IdTh,
  BaixarTh,
  CustomersTh,
  VencimentoTh,
  IconTh,
  ReferenciaTh,
  DateTh,
  FilterHeaderSelect,
  FilterIcon,
  FilterLabel
} from './requestTable.styled';
import OrderContainer from '../../../components/shared/table/OrderContainer'

export default ({current, sort, sortHandler}) => (
  <tr>
    <IdTh>
      <OrderContainer tag="id" current={current} sort={sort} changeCurrent={sortHandler}>ID Cobrança</OrderContainer>
    </IdTh>
    <IdTh>
      <OrderContainer tag="id" current={current} sort={sort} changeCurrent={sortHandler}>ID-FC</OrderContainer>
    </IdTh>
    <DateTh>
      Valor
    </DateTh>
    <ReferenciaTh>
      Referência
    </ReferenciaTh>
    <VencimentoTh>
      Vencimento
    </VencimentoTh>
    <DateTh>
      Status
    </DateTh>
    <BaixarTh>
      Nota fiscal
    </BaixarTh>
    <BaixarTh>
      Visualizar
    </BaixarTh>
  </tr>
);